export { default } from "./Slide.js";